import { Tooltip } from 'antd'
import { AgreementContentType } from '../../../constants'
import { ActionBtns } from './ActionBtns'
import { EditOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { useState } from 'react'

const renderAgreementNumber = (value) => {
  return <span style={{ marginRight: 10, fontWeight: 600 }}>{value}</span>
}

const ShowSummarizedActions = ({
  paragraphContent,
  setToggleFull,
  isFull,
  isNotFull,
  hideToggleFull,
  agreementNumber,
}) => {
  return paragraphContent.map((p, index) => {
    const transformedP = p.replace(/\s+/g, ' ').trim()
    let numbering = ''
    if (agreementNumber) {
      const lastChar = agreementNumber.slice(-1)
      numbering = `${agreementNumber.slice(0, -1)}${index + Number(lastChar)}`
    }
    return (
      <p key={index}>
        {transformedP && renderAgreementNumber(numbering)}
        {transformedP}{' '}
        {isFull && index === paragraphContent.length - 1 && !hideToggleFull && (
          <span onClick={() => setToggleFull(false)} className="toggler full">
            See summary clause
          </span>
        )}
        {isNotFull &&
          index === paragraphContent.length - 1 &&
          !hideToggleFull && (
            <span
              onClick={() => setToggleFull(true)}
              className="toggler summary">
              See legal clause
            </span>
          )}
      </p>
    )
  })
}

export const AgreementItem = ({
  editingAgreement,
  setEditAgreement,
  cancelEditAgreement,
  saveUpdatedAgreement,
  agreementContent,
  setAgreementContent,
  agreement,
  addAgreement,
  removeAgreement,
  isChecked,
  htmlFor,
  displayText,
  hideToggleFull,
  showFullAgreement,
  agreementNumber,
  startWithFull,
}) => {
  const {
    auth: { user },
  } = useSelector((state) => state)
  const [toggleFull, setToggleFull] = useState(startWithFull)

  const checkItem = (e, category) => {
    const { name, checked } = e.target
    if (checked) {
      addAgreement(category, name)
    } else {
      removeAgreement(category, name)
    }
  }

  const changeInput = (e) => {
    const { name, value } = e.target
    addAgreement(name, value)
  }

  const isNotFull = agreement.summary && !toggleFull
  const isFull = agreement.summary && toggleFull

  const paragraphContent =
    (isNotFull && !showFullAgreement
      ? `${agreement.summary}`
      : displayText || agreement.content
    )?.split('/') || []

  return (
    <div
      className={`${
        agreement.contentType === AgreementContentType.CHECKBOX
          ? 'tikbox-form-element '
          : agreement.contentType === AgreementContentType.RADIO
          ? 'length-input-container '
          : ''
      }agreement-item`}>
      {editingAgreement === agreement._id ? (
        <textarea
          type="text"
          value={agreementContent}
          onChange={(e) => setAgreementContent(e.target.value)}>
          {agreementContent}
        </textarea>
      ) : agreement.contentType === AgreementContentType.PARAGRAPH ? (
        <div
          className={`agreement-paragraph${
            isNotFull && !showFullAgreement
              ? ' summary'
              : isFull || showFullAgreement
              ? ' full'
              : ''
          }`}>
          <ShowSummarizedActions
            paragraphContent={paragraphContent}
            setToggleFull={setToggleFull}
            isFull={isFull}
            isNotFull={isNotFull}
            hideToggleFull={hideToggleFull}
            agreementNumber={agreementNumber}
          />
        </div>
      ) : agreement.contentType === AgreementContentType.TITLE ? (
        <h2>{agreement.content}</h2>
      ) : agreement.contentType === AgreementContentType.CHECKBOX ? (
        <>
          <input
            type="checkbox"
            id={agreement._id}
            checked={isChecked}
            name={agreement._id}
            onChange={(e) => checkItem(e, agreement.category)}
          />
          <label htmlFor={agreement._id}>{agreement.content}</label>
        </>
      ) : agreement.contentType === AgreementContentType.RADIO ? (
        <>
          <input
            onChange={changeInput}
            name="royaltyLength"
            id={agreement._id}
            type="radio"
            checked={isChecked}
            value={agreement._id}
          />{' '}
          <label style={{ marginLeft: -40 }} htmlFor={agreement._id}>
            {agreement.content}
          </label>
        </>
      ) : agreement.contentType === AgreementContentType.SPAN ? (
        <span>{agreement.content}</span>
      ) : agreement.contentType === AgreementContentType.LABEL ? (
        <label className={htmlFor} htmlFor={htmlFor}>
          {agreement.content}
        </label>
      ) : agreement.contentType === AgreementContentType.SUBTITLE ? (
        <h3>
          {renderAgreementNumber(agreementNumber)}
          {agreement.content}
        </h3>
      ) : agreement.contentType === AgreementContentType.OL ? (
        <li
          style={{ listStyleType: 'lower-roman' }}
          className={`agreement-list${
            isNotFull && !showFullAgreement
              ? ' summary'
              : isFull || showFullAgreement
              ? ' full'
              : ''
          }`}>
          <ShowSummarizedActions
            paragraphContent={paragraphContent}
            setToggleFull={setToggleFull}
            isFull={isFull}
            isNotFull={isNotFull}
            hideToggleFull={hideToggleFull}
            agreementNumber={agreementNumber}
          />
        </li>
      ) : (
        <div>NONE</div>
      )}

      {(user.isAdmin || !!user?.ownerOrganization) &&
      editingAgreement === agreement._id ? (
        <ActionBtns
          cancelEditAgreement={cancelEditAgreement}
          saveUpdatedAgreement={saveUpdatedAgreement}
        />
      ) : (
        (user.isAdmin || !!user?.ownerOrganization) && (
          <Tooltip title="Edit agreement">
            <EditOutlined
              onClick={() => setEditAgreement(agreement._id, agreement.content)}
            />
          </Tooltip>
        )
      )}
    </div>
  )
}
